import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
  Skeleton } from '@mui/material';
import { TFunction } from 'i18next';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { TransferBlockchainData } from '../../types';

import { Row } from './components/row';
import { columns } from './utils/index';

type TableWireTransfersProps = {
  t: TFunction,
  wireTransferPages: Array<TransferBlockchainData[]>,
  currentPage: number,
  totalPages: number,
  rowsPerPage: number,
  totalRows: number,
  setCurrentPage: React.Dispatch<React.SetStateAction<number>>,
  changeRowsPerPage: ({ rows }: { rows: number }) => void,
  handleToggleModals: (location: string, data: TransferBlockchainData | undefined) => void,
  isDataLoading: boolean
}

export const TableWireTransfers: FC<TableWireTransfersProps> = ({
  t,
  wireTransferPages,
  currentPage,
  setCurrentPage,
  changeRowsPerPage,
  totalPages,
  rowsPerPage,
  totalRows,
  handleToggleModals,
  isDataLoading
}) => {
  const { i18n } = useTranslation();
  return (
    <TableContainer>
      <Table stickyHeader>
        <TableHead>
          <TableRow>
            {columns(t).map((column) => (
              <TableCell
                style={{
                  backgroundColor: 'white',
                  color: '#000000',
                }}
                key={column.id}
              >
                {column.label}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {isDataLoading && (
            <>
              {[...Array(10)].map(() => (
                <TableRow>
                  {[...Array(6)].map(index => (
                    <TableCell key={index}>
                      <Skeleton />
                    </TableCell>
                  ))}
                </TableRow>
              ))}
            </>
          )}
          {totalPages > currentPage - 1 && wireTransferPages[currentPage - 1].map((transfer) => (
            <Row
              key={transfer.reference}
              t={t}
              transfer={transfer}
              onClick={() => {
                handleToggleModals('authTransfer', transfer);
              }}
              onViewChainClick={() => handleToggleModals("audit", transfer)}
            />
          ))}
        </TableBody>
        <TableFooter>
          <TableRow>
            <TablePagination
              rowsPerPageOptions={[5, 8, 10, 25]}
              rowsPerPage={rowsPerPage}
              count={totalRows}
              page={currentPage - 1}
              onPageChange={(e, page) => { setCurrentPage(page + 1); }}
              onRowsPerPageChange={(e) => {
                const value = Number(e.target.value);
                if (!Number.isNaN(value)) {
                  changeRowsPerPage({ rows: value });
                }
              }}
              labelRowsPerPage={t('common:rows-per-page')}
              SelectProps={{
                inputProps: { 'aria-label': t('common:rows-per-page'), },
                native: true,
              }}
            />
          </TableRow>
        </TableFooter>
      </Table>
    </TableContainer>
  );
};
